import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import './Button.scss'

const ButtonLink = ({ children, color, model, size, radius, className, href='/', target, rel, title, onClick, style, onMouseEnter, onMouseLeave, shake }) => (
    <a className={cx('button', model, size, radius, className, color, (shake && 'shake'))}
            href={href}
            target={target}
            title={title}
            onClick={onClick}
            style={style}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            rel={rel ? rel : target === '_blank' ? 'noopener noreferrer' : ''}>
        {children}
    </a>
)

ButtonLink.propTypes = {
    className: PropTypes.string,
    children: PropTypes.any,
    color: PropTypes.string,
    href: PropTypes.string,
    model: PropTypes.oneOf(['outline', 'secondary', 'success', 'alert', 'warning']),
    radius: PropTypes.oneOf(['half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded']),
    size: PropTypes.string,
    target: PropTypes.oneOf(['_blank', '_parent', '_self', '_top']),
    title: PropTypes.string
}

export default ButtonLink



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/Button/ButtonLink.jsx